import './index.scss'
import LogoW from '../../../assets/images/logo-w-home.png'
import React from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'
import gsap from 'gsap-trial'
import DrawSVGPlugin from 'gsap-trial'

export const Logo = () => {

  const solidLogoRef = useRef();

  useEffect( () => {
    gsap.registerPlugin(DrawSVGPlugin)

    gsap.timeline().to(solidLogoRef.current, {
        duration: 4,
        opacity: 1
      }
    )

  }, [])


  return (
    <div className='logo-container'>
        <img className='solid-logo' ref={ solidLogoRef } src={ LogoW } alt="W" />
    </div>
  )
}

